/**
 * 活动配置时间 → 毫秒时间戳。
 * 服务端为 RFC3339（含时区偏移，如 +07:00），Date.parse 会转为 UTC 毫秒，与本地时区无关。
 */
export const parseActTimeToMs = (value) => {
  if (value == null || value === '') return NaN
  if (typeof value === 'number') {
    return value > 1e12 ? value : value * 1000
  }
  const text = String(value).trim()
  if (/^\d+$/.test(text)) {
    const num = Number(text)
    return num > 1e12 ? num : num * 1000
  }
  const parsed = Date.parse(text)
  return Number.isNaN(parsed) ? NaN : parsed
}

export const formatCountdownParts = (diffMs) => {
  const diff = Math.max(0, Math.floor(diffMs / 1000))
  const day = Math.floor(diff / 86400)
  const hour = Math.floor((diff % 86400) / 3600)
  const minute = Math.floor((diff % 3600) / 60)
  const second = diff % 60
  const pad2 = (n) => (n >= 10 ? String(n) : `0${n}`)
  return {
    day: pad2(day),
    hour: pad2(hour),
    minute: pad2(minute),
    second: pad2(second),
    hasDay: day > 0,
  }
}
